import { Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import form from '@/components/services/url-shortener-tracking/form'

function renderForm(h) {
  return h(
    form,
    {
      props: {
        value: this.data,
        paddless: true
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services['url-shortener-tracking']}.titles.details`),
        value: this.proxy,
        maxWidth: 500
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderForm.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
